<div class="inbuilt-donut-v2-wrapper">
<div class="donut-chart" id="d">
	<div *ngIf="donutPanels.length > 0" class="donut-panels-container">
		<div *ngFor="let panel of donutPanels; let i = index; let isLast = last" class="donut-panel-wrap">
			<div class="donut-panel-header">{{ panel.header }}</div>
			<div class="donut-host-layout">
				<div class="donut-host-chart">
					<ng-container [ngSwitch]="isDonutVisual(panel.element)">
						<app-inbuilt-donut-chart
							*ngSwitchCase="'donut_chart'"
							[width]="getDonutChartWidth()"
							[height]="getDonutChartHeight()"
							[isInfraChart]="true"
							[showMiddleTitle]="false"
							[externalLabelScale]="getDonutExternalLabelScale()"
							[selectedYear]="''"
							[config]="config"
							[elementData]="panel.element"
							(chartReady)="onChartReady(i)"
							(seriesChange)="onPanelSeriesChange(i, $event)"
							titleMiddle="Total">
						</app-inbuilt-donut-chart>
						<app-inbuilt-speedometer-v2
							*ngSwitchCase="'speedometer'"
							[config]="config"
							[elementData]="panel.element">
						</app-inbuilt-speedometer-v2>
						<app-inbuilt-bar-chart-v2
							*ngSwitchCase="'bar_chart'"
							[config]="config"
							[elementData]="panel.element">
						</app-inbuilt-bar-chart-v2>

						<app-column-chart-v2
							*ngSwitchCase="'column_chart'"
							[config]="config"
							[elementData]="panel.element">
						</app-column-chart-v2>

						<app-inbuilt-matrix
							*ngSwitchCase="'metrics'"
							[config]="config"
							[elementData]="panel.element">
						</app-inbuilt-matrix>

						<app-inbuilt-table-v2
							*ngSwitchCase="'table'"
							[config]="config"
							[elementData]="panel.element">
						</app-inbuilt-table-v2>

						<app-inbuilt-drill-down-matrix
							*ngSwitchCase="'drill_down_matrix'"
							[config]="config"
							[elementData]="panel.element">
						</app-inbuilt-drill-down-matrix>

						<app-parent-child-table
							*ngSwitchCase="'parent_child_table'"
							[config]="config"
							[elementData]="panel.element">
						</app-parent-child-table>

						<div *ngSwitchDefault class="donut-state">
							Visual type is not supported yet.
						</div>
					</ng-container>
				</div>

				<div class="donut-host-legend" *ngIf="panel.legendData.length > 0">
					<div class="legend-row" *ngFor="let slice of panel.legendData">
						<span class="legend-swatch" [style.backgroundColor]="slice.color"></span>
						<div class="legend-text">
							<div class="legend-label">{{ slice.label ? slice.label.split('_').join(' ') : '' }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</div>
